import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import BgImg from "../../../images/solution/real-estate-updated/unique_back.webp";

function Uniquerealcta() {
  return (
    <section
      className="million_dollar_app unique_cta text_white"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Have a <span>Unique Real Estate</span> Application Development
              Idea?
            </h2>
            <p>
              TekRevol's real estate app developers help you build a
              feature-rich real estate app with automation.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book A Free Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <div className="million-dollar-img">
              <StaticImage
                src="../../../images/solution/real-estate-updated/unique_img.webp"
                alt="tekrevol_web"
                layout="constrained"
                className="d-none d-md-block"
                placeholder="blurred"
                formats={["webp"]}
                width={782}
                height={708}
              />
              <StaticImage
                src="../../../images/solution/real-estate-updated/unique_img_mob.webp"
                alt="tekrevol_web"
                layout="constrained"
                className="d-block d-md-none"
                placeholder="blurred"
                formats={["webp"]}
                width={646}
                height={669}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Uniquerealcta;
